import { inject } from '@angular/core';
import { createSelector, Store } from '@ngrx/store';
import { TscConfig, TscUserContext } from '@soff/tsc-ui/config';
import { AccountActions, AccountSelectors } from './shared/state/account';

/** Maps the SOFF account store to the ticket UI's user context. */
export const selectTscUserContext = createSelector(
  AccountSelectors.getUserProfile,
  AccountSelectors.getUserAuthorization,
  (profile, authorization): TscUserContext | null =>
    profile?.userId
      ? {
          userId: profile.userId,
          activeDirectoryRoles: authorization?.activeDirectoryRoles ?? [],
          salesOrganizations: authorization?.salesOrganizations ?? [],
        }
      : null
);

/**
 * SOFF adapter for `provideTsc`: user context from the account store, links to the SOFF machine and
 * employee pages, assets served from `assets/`. The language is omitted: SOFF switches languages via ngx-translate,
 * so the default (`onLangChange`) fits. Must run in an injection context.
 */
export function soffTscConfigFactory(): TscConfig {
  const store = inject(Store);
  return {
    userContext: store.selectSignal(selectTscUserContext),
    refreshUserContext: () => store.dispatch(new AccountActions.LoadProfile()),
    links: {
      machine: machineId => `/app/machines/${machineId}`,
      employee: employeeId => `/app/employees/${employeeId}`,
    },
    assetsBaseUrl: 'assets/',
  };
}
